/** Format a Unix-seconds or ISO timestamp as a human-readable local time. */
export function formatTime(value: number | string | null | undefined): string {
  if (value === null || value === undefined || value === '') {
    return '—';
  }
  const date =
    typeof value === 'number' ? new Date(value * (value > 1e12 ? 1 : 1000)) : new Date(value);
  if (Number.isNaN(date.getTime())) {
    return '—';
  }
  return date.toLocaleString();
}

/** Relative time, e.g. "5 minutes ago". Falls back to absolute on > 7 days. */
export function timeAgo(value: number | string | null | undefined): string {
  if (value === null || value === undefined || value === '') {
    return '—';
  }
  const ts =
    typeof value === 'number' ? (value > 1e12 ? value : value * 1000) : new Date(value).getTime();
  if (Number.isNaN(ts)) {
    return '—';
  }
  const diffSec = Math.floor((Date.now() - ts) / 1000);
  if (diffSec < 60) {
    return `${diffSec}s ago`;
  }
  if (diffSec < 3600) {
    return `${Math.floor(diffSec / 60)}m ago`;
  }
  if (diffSec < 86400) {
    return `${Math.floor(diffSec / 3600)}h ago`;
  }
  if (diffSec < 7 * 86400) {
    return `${Math.floor(diffSec / 86400)}d ago`;
  }
  return formatTime(value);
}

export function formatMoney(
  amountCents: number | null | undefined,
  currency: string | null | undefined,
): string {
  if (amountCents === null || amountCents === undefined || !currency) {
    return '—';
  }
  return new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: currency.toUpperCase(),
  }).format(amountCents / 100);
}

export function formatCompactNumber(value: number | null | undefined): string {
  if (value === null || value === undefined) {
    return '—';
  }
  return new Intl.NumberFormat(undefined, {
    notation: 'compact',
    maximumFractionDigits: 1,
  }).format(value);
}
